// theme.js
import { createTheme } from '@mui/material/styles';
const theme = createTheme({
    typography: {
        fontFamily: '"Roboto", "Montserrat", sans-serif',
    },
    breakpoints: {
        values: {
            xs: 300,
            sm: 760,
            xsm: 1390,
            md: 1400,
            xmd:1500,
            lg: 1660,
            macScreen:1670,
            mlg: 1800,
            xl: 2000
        },
    },
});

export default theme;
